var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['sign-tit-wrap', _vm.simplicity ? 'simplicity' : ''],style:(`width:${_vm.width}px;height:${_vm.height}px`)},[_c('div',{staticClass:"sign-tit"},[_c('div',{staticClass:"sign",style:(`background: ${_vm.color}`)}),_c('span',[_vm._v(_vm._s(_vm.title))])]),(_vm.arrows)?_c('van-icon',{attrs:{"name":"arrow","size":"20px"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }